import {Injectable} from '@angular/core';
import {HttpClient, HttpRequest, HttpEvent, HttpParams, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constants} from '../constants/constants';
import {CrudService} from './crud.service';
import {Spring} from '../constants/spring';

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http: HttpClient, private constants: Constants, private crud: CrudService, private spring: Spring) {
  }

  // Metodo Carga Excel Factoraje

  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('files', file);
    const req = new HttpRequest('POST', `${this.constants.API_REST}upload`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  // Metodo para Guardado de información de tablas

  uploadFTP(file: File, id: number, idtipo: number, tipo: string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('files', file);
    const req = new HttpRequest('POST', `${this.constants.API_REST}upload/ftp/${id}&${idtipo}&${tipo}`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  // Metodo para borrar los archivos
  deleteFile(filename: string) {
    return this.http.get(`${this.constants.API_REST}delete/${filename}`);
  }

  // Carga Pagos Lotes

  uploadExcel(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('files', file);
    const req = new HttpRequest('POST', `${this.constants.API_REST}cargaExcel`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }


  //*********************** Nuevos metodos para optimización **** EN PROCESO DE IMPLEMENTACIÓN ****/

  // Metodo que envia los archivos al endpoint /upload
  uploadOptimizado(file: File, tablaAdjuntos: string, rutaSFTP: string, adjunto: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('files', file);
    const req = new HttpRequest('POST', `${this.constants.API_REST}upload/${tablaAdjuntos}&${rutaSFTP}&${adjunto.idtipadj}&${adjunto.id}&${adjunto.comentarios}`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  getArchivo(archivo: string, rutaSFTP: string) {
    return this.crud.getText(`download/${archivo}&${rutaSFTP}`);
  }

  deleteSFTPBD(filename: string, rutaSFTP: string, tabla: string, id: number) {
    return this.crud.delete(`deleteSFTPBD/${filename}&${rutaSFTP}&${tabla}&${id}`);
  }


}
